// extracted by mini-css-extract-plugin
export default {"pdfImage":"PdfPreview_pdfImage__b12Fa","pdfImageSpinner":"PdfPreview_pdfImageSpinner__5U7dt","link":"PdfPreview_link__LHka6"};